import store from '@state/store'

// auth related routes
const authRoutes = [
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/pages/account/login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'Dashboard' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        // Navigate back to previous page, or home as a fallback
        next({ name: 'login' })
      },
    },
  },
]

// dashboard
const dashboardRoutes = [
  {
    path: '/',
    name: 'Dashboard',
    icon: 'home',
    component: () => lazyLoadView(import('@views/pages/dashboard/dashboard')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

//  apps
 const registerRoutes = [
   {
     path: '/register',
     name: 'Cadastros',
     icon: 'cloud',
     meta: { authRequired: true },
     component: {
       render(c) {
         return c('router-view')
       },
     },
     children: [
      {
        path: 'usuario',
        name: 'Usuários',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/cadastro/usuarios')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
        {
          path: 'produtos',
          name: 'Produtos',
          icon: 'cloud',
          component: () => lazyLoadView(import('@views/pages/cadastro/produtos')),
          meta: { authRequired: true },
          props: (route) => ({ user: store.state.auth.currentUser || {} }),
        },
        {
          path: 'estoque',
          name: 'Estoque',
          icon: 'cloud',
          component: () => lazyLoadView(import('@views/pages/cadastro/estoque')),
          meta: { authRequired: true },
          props: (route) => ({ user: store.state.auth.currentUser || {} }),
        },
     ],
   },
 ]


const authProtectedRoutes = [
  ...dashboardRoutes,
  ...registerRoutes
]

const allRoutes = [...authRoutes, ...authProtectedRoutes]

export { allRoutes, authProtectedRoutes }

function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    delay: 400,
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      return h(AsyncHandler, data, children)
    },
  })
}
